export const BroadcastEvents = {
    BREADCRUMB: 'BREADCRUMB'
};